import React from 'react'
import { Link } from "react-router-dom";


const TurnoverGraph = () => {
    return (
        <>

            <section className="section-about" style={{ overflow: "hidden", marginTop: "-100px" }}>
                <div className="position-relative section-space">
                    <div className="container">
                        <div className="row justify-content-between align-items-center gy-5 flex-column-reverse flex-lg-row">
                            <div className="col-lg-5 col-xxl-6">
                                <div className="about-left-block">
                                    <div className="image-block animate-bottom-to-top">
                                        <img src="https://res.cloudinary.com/dnquglkeh/image/upload/q_auto/f_auto/v1775295905/ess_vr6jvp.png" alt="about-img-1" width={439} height={538} className="img-fluid animate-bottom-to-top" data-animation-duration={1} data-animation-delay="0.5" />
                                    </div>
                                    {/* <div className="image-block">
                                            <img src="assets/images/about-img-1.jpg" alt="about-img-1" width={375} height={359} className="img-fluid animate-left-to-right" data-animation-duration={1} data-animation-delay={1} />
                                        </div> */}
                                    <img src="assets/images/abstract/dot-1.svg" alt="dot-1" width={198} height={93} className="img-fluid animate-top-to-bottom" data-animation-duration={1} />
                                    {/* <div className="about-shape-block animate-zoom-in" data-animation-duration={1} data-animation-delay="0.5">
                                            <div className="about-shape-inner-block">
                                                <img src="assets/images/abstract/star-curve-shape-blue.svg" alt="star-curve-shape-blue" width={200} height={200} className="img-fluid" />
                                                <div className="about-shape-text">
                                                    <span>24+</span>
                                                    Our Experience
                                                </div>
                                            </div>
                                        </div> */}
                                </div>
                            </div>
                            <div className="col-lg-7 col-xxl-5">
                                <div className="about-right-block">
                                    <div className="about-content">
                                        <div className="section-content-block">
                                            <span className="section-tag">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="section-title is-text-dark">Company <strong> Growth Chart </strong>
                                                in Lakhs (₹)</h2>
                                            <p className="section-text" style={{textAlign:"justify"}}>
                                                Rahul Logistics is a fast-growing and reliable logistics  committed to delivering efficient, secure, and timely transportation solutions across regions. With a strong focus on customer satisfaction and operational excellence, we have steadily built our reputation in the logistics industry.
                                            </p>
                                            <p className="section-text" style={{textAlign:"justify"}}>
                                               Over the years, our company has shown consistent growth in turnover, reflecting our expanding network, trusted partnerships, and increasing client base. Starting from modest beginnings, Rahul Logistics has scaled its operations significantly, achieving impressive growth measured in lakhs (₹) year after year. 
                                            </p>
                                        </div>
                                        <hr />
                                        <div>
                                            <div className="row mb-4">
                                                <ul className="col-auto content-list content-list-1">
                                                    <li>🚛 A well-managed fleet and transportation network</li>
                                                    <li> 📦 Safe and timely delivery of goods </li>
                                                </ul>
                                                <ul className="col-auto content-list content-list-1">
                                                    <li>🤝 Strong relationships with clients and partners</li>
                                                    <li>📈 Continuous improvement and adoption of modern logistics solutions</li>
                                                </ul>
                                            </div>

                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Section Images */}
                    <div className="about-section-img">
                        <img src="assets/images/about-section-img-1.png" alt="about-section-img" width={278} height={168} className="animate-left-to-right" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-1.svg" alt="about-section-abstract-img-1" width={211} height={375} className="animate-zoom-in" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-2.svg" alt="about-section-abstract-img-2" width={332} height={480} className="animate-zoom-in" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-3.svg" alt="about-section-abstract-img-3" width={226} height={115} className="animate-zoom-in" data-animation-duration="1.5" />
                    </div>
                    {/* Section Images */}
                </div>
            </section>

        </>
    )
}

export default TurnoverGraph